import React, { CSSProperties } from 'react'
import Select, { Props } from 'react-select'
import styled from 'styled-components'

import { inputBackground } from '../../colors'
import { Column } from '../../styled-components/layout'
import { Label, Sublabel } from '../../styled-components/typography'
import { withTranslation, WithTranslation } from 'react-i18next'

const selectStyles = {
    control: () => ({
        backgroundColor: inputBackground,
        boxShadow: 'inset 0 1px 3px 1px rgba(0,0,0,0.10)',
        minHeight: '35px',
        border: 'none',
        fontSize: '14px',
        color: 'black',
        padding: '1px',
        marginTop: '5px',
        borderRadius: 0,
        display: 'flex',
        flexDirection: 'column',
    } as CSSProperties),
    singleValue: () => ({
        color: 'black'
    } as CSSProperties)
};

interface InputSelectProps extends Props, WithTranslation {
    label?: string,
    sublabel?: string,
    withCaret?: boolean
}
const InputSelect: React.FC<InputSelectProps & {className?: string}> = ({label, sublabel, withCaret, t, className, ...props}) => (
    <Container className={className}>
        {label && (<Label>{label}</Label>)}
        {sublabel && (<Sublabel>{sublabel}</Sublabel>)}
        <Select
            styles={selectStyles}
            components={{ IndicatorsContainer: withCaret ? () => (<DownCaret />) : () => null }}
            noOptionsMessage={() => t('noOptions')}
            {...props}
        />
    </Container>
);

const Container = styled(Column)`
  margin-bottom: 20px;
`;

const DownCaret = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 7px solid black;
  right: 15px;
  top: 21px;
`;

export default withTranslation()(InputSelect);
